import { CompetitionType } from '@/modules/tourneys/inviteFriends/InviteFriendsPage';
import { InitialDataTourneys } from '@/store';
import { DatosParticipanteMiniLigasTO } from '@/types/minileagues';

export const tournamentUtilService = (
  type: string,
  tourneyData: InitialDataTourneys
) => {
  const getStatusValidation = (idUsuario: number, members?: Set<number>) => {
    let status = 'Invitar';
    let isGuestPresent;
    let isPlayerPresent;
    let isMember = false;
    if (type === CompetitionType.MINILEAGUES) {
      isGuestPresent = tourneyData.minileagueInvited?.some(
        (guest: DatosParticipanteMiniLigasTO) => {
          return guest.part?.idUsuario === idUsuario;
        }
      );
      isPlayerPresent = tourneyData.minileagueMembers?.some(
        (player: DatosParticipanteMiniLigasTO) => {
          return player.part?.idUsuario === idUsuario;
        }
      );
      if (members !== undefined && members.size > 0) {
        isMember = members?.has(idUsuario);
      }
    } else {
      isGuestPresent = tourneyData.tourneyGuests?.some((guest: any) => {
        return guest.idUsuario === idUsuario;
      });
      isPlayerPresent = tourneyData.tourneyPlayers?.some((player: any) => {
        return player.idUsuario === idUsuario;
      });
      if (members !== undefined && members.size > 0) {
        isMember = members?.has(idUsuario);
      }
    }
    if (isGuestPresent) {
      status = 'Invitado';
    } else if (isPlayerPresent || isMember) {
      status = 'Participando';
    }
    return status;
  };

  return {
    getStatusValidation,
  };
};
